
  import { onMounted, ref, defineComponent } from "vue"
  import { useI18n } from "vue-i18n"
  import "./scss/chooseLang/ChooseLang.scss"

  export default defineComponent({
    name: "ChooseLang",
    setup() {
      const { locale, t } = useI18n({ useScope: "global" })
      const activeLang = ref(locale.value)
      const translateTitle: any = ref(null)
      const langList: any = ref(null)
      const langMenuList: any = ref(null)
      const isLang = ref(false)

      const listLangs = ["en", "ru"]

      // Не используется !!!
      // const observer = new ResizeObserver((entries: any) => {
      //   for (const entry of entries) {
      //     const width = entry.contentRect.width
      //     if (width < 724) translateTitle.value.className = "lang__title menu-link"
      //     else translateTitle.value.className = "lang__title header-link"
      //   }
      // })
      // observer.observe(document.documentElement)

      onMounted(() => {
        const lang = window.localStorage.getItem("userlang")
        if (lang == null) {
          window.localStorage.setItem("userlang", "ru")
          locale.value = "ru"
        } else {
          activeLang.value = lang
          locale.value = lang
        }
      })

      const editLang = (lang: string) => {
        if (lang != activeLang.value) {
          activeLang.value = lang
          window.localStorage.setItem("userlang", lang)
          locale.value = lang
        }
      }

      const setLangs = () => isLang.value = !isLang.value

      return {
        t, activeLang, listLangs, editLang, isLang,
        translateTitle, langList, langMenuList, setLangs
      }
    },
  })
